import { type Listing } from '@/features/listing/types/listing-types';
import sendHttpError from '@/libs/logger/requests/send-http-error';

interface GetMegaphoneCountPropsBase {
  searchParams: string;
  currencyName: string;
  bearerToken: string;
}

interface GetMegaphoneCountPropsWithListing extends GetMegaphoneCountPropsBase {
  listing: Listing;
}

interface GetMegaphoneCountPropsWithoutListing extends GetMegaphoneCountPropsBase {
  listing?: undefined;
}

interface GetMegaphoneCountReturn {
  count: number;
}

interface GetMegaphoneCountWithListingReturn extends Listing {
  megaphoneCount: number;
}

// Overloaded function signatures
export default async function getMegaphoneCount(
  props: GetMegaphoneCountPropsWithListing
): Promise<GetMegaphoneCountWithListingReturn>;

export default async function getMegaphoneCount(
  props: GetMegaphoneCountPropsWithoutListing
): Promise<GetMegaphoneCountReturn>;

export default async function getMegaphoneCount(props: GetMegaphoneCountPropsWithListing | GetMegaphoneCountPropsWithoutListing): Promise<GetMegaphoneCountReturn | GetMegaphoneCountWithListingReturn> {
  const {
    bearerToken,
    currencyName,
    listing,
    searchParams,
  } = props;

  // https://roomster.com/api/megaphone?search_params.age.max=99&search_params.age.min=18&search_params.budget.max=5000&search_params.budget.min=0&search_params.service_type=2
  const url = `${process.env.NEXT_PUBLIC_API_URL}/v1/megaphone?${searchParams}`;

  const headers: HeadersInit = {
    Currency: currencyName,
    Authorization: `Bearer ${bearerToken}`,
  };

  const result = await fetch(url, { cache: 'no-store', headers });

  // TODO: rewrite to flow without break APP
  if (!result.ok) {
    sendHttpError({
      baseName: 'Get Megaphone Count',
      functionName: 'getMegaphoneCount',
      method: 'GET',
      statusCode: result.status,
      url,
    });
    // throw new Error('Failed to get Megaphone Count');

    return listing ? { ...listing, megaphoneCount: 0 } : { count: 0 };
  }

  const { count } = await result.json() as { count: number };

  return listing ? { ...listing, megaphoneCount: count } : { count };
}
